import React, { Component } from 'react';
import DataTablesCreate from '../components/DataTablesCreate';
import '../css/dataTables.css';
import $ from 'jquery';
import { ApiClient } from "../libs/apiClient";
import config from "../config";

let headers = [
    { title: 'Serie' },
    { title: 'DocNum' },
    { title: 'Fecha' },
    { title: 'CardCode' },
    { title: 'Nombre' },
    { title: 'Comentarios' },
];

let apiClient = ApiClient.getInstance();

class SelectOfModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            enable: false,
            checkboxArray: (new Map()),
        };
        this.dataTable = null;
    }



    closeSelectOf = async () => {
        $('#selectOfModal').modal('hide');
        this.cleanData();
        this.disableDataTable()
    };

    closeAction = () => {
        let clear = () => this.cleanData();
        $('#selectOfModal').on('hide.bs.modal', function () {
            //console.log("cerrar selectOfModal");
            clear();
        });
    };

    cleanData = () => {
        setTimeout(() => {
            this.setState({
                data: [],
            })
        }, 50)

    };

    enableDataTable = () => {
        this.setState({
            enable: true
        })
        this.cleanData()
        setTimeout(() => {
            this.dataTable.refreshDates()
            this.dataTable.searchDocuments();
        }, 100)

    }

    disableDataTable = () => {
        this.setState({
            enable: false
        })
    }

    search = async date => {
        const { newOrderModel, showAlert, enableSpinner, view } = this.props;
        let table = this.selectDocType(newOrderModel.SelectOf);

        let data = {
            dateInit: date.dateInit,
            dateFinal: date.dateFinal,
            docType: table.tableName,
            cardCode: newOrderModel.CardCode,
            view
        };
        enableSpinner(true);
        let infoResponse = await apiClient.getDocuments(data);

        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };
        let seriesResponse = await apiClient.getSeries(dataSerie);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let ValidateSeries = user[table.nameSeries] ? user[table.nameSeries] : "";

        let newDocumentsfilterSeries = [];

        if (table.tableName !== 'OIPF') {
            if (!user || ValidateSeries === "") {
                enableSpinner(false);
                return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador" });
            }

            let seriesUsers = ValidateSeries.split("|");
            let newArraySeries = [];

            for (const serieUser of seriesUsers) {
                for (const serieResponse of seriesResponse.data) {
                    if (Number(serieResponse.Series) === Number(serieUser) && !newArraySeries.some(item => Number(item.Series) === Number(serieResponse.Series))) {
                        newArraySeries.push(serieResponse);
                    }
                }
            }

            if (newArraySeries.length === 0) {
                enableSpinner(false);
                return showAlert({ type: 'warning', message: "El usuario no tiene serie permitida de escritura y lectura" });
            }

            if (table.tableName === 'OWTQ') {
                const whsCode = user?.Branch?.ProjectCode || "";
                const availableWhs = user?.Branch?.AvailableWhs;

                for (const document of infoResponse.data) {
                    if ((Array.isArray(availableWhs) && availableWhs.some(whs => whs.WhsCode === document.Filler)) ||
                        (!Array.isArray(availableWhs) && document.Filler === whsCode)) {
                        newDocumentsfilterSeries.push(document);
                    }
                }
            } else {
                for (const document of infoResponse.data) {
                    for (const serie of newArraySeries) {
                        if (Number(document.Series) === Number(serie.Series) && document.DocSubType === serie.DocSubType) {
                            newDocumentsfilterSeries.push(document);
                        }
                    }
                }
            }
        } else {
            newDocumentsfilterSeries = infoResponse.data || [];
        }


        enableSpinner(false);
        this.setState({
            data: newDocumentsfilterSeries,
            enable: false,
            checkboxArray: (new Map()),
        });
        setTimeout(() => {
            this.setState({
                enable: true
            })
        }, 20)

        setTimeout(() => {
            this.dataTable.refreshDates();
        }, 100)
    };

    selectDocType = table => {
        let docType = '';
        let docSubType = '';
        let nameSeries = '';
        let tableName = '';

        switch (table) {
            case 'quotations':
                docType = '23';
                tableName = 'OQUT';
                docSubType = '--';
                nameSeries = 'U_FMB_ValidateSeriesOQUT';
                break;
            case 'orderSales':
                docType = '17';
                tableName = 'ORDR';
                docSubType = '--';
                nameSeries = 'U_FMB_ValidateSeriesORDR';
                break;
            case 'deliveries':
                docType = '15';
                docSubType = '--';
                tableName = 'ODLN';
                nameSeries = 'U_FMB_ValidateSeriesODLN';
                break;
            case 'invoice':
                docType = '13';
                docSubType = '--';
                tableName = 'OINV';
                nameSeries = 'U_FMB_ValidateSeriesOINV';
                break;
            case 'return':
                docType = '16';
                docSubType = '--';
                tableName = 'ORDN';
                nameSeries = 'U_FMB_ValidateSeriesORDN';
                break;
            case 'PurchaseOrder':
                docType = '22';
                docSubType = '--';
                tableName = 'OPOR';
                nameSeries = 'U_FMB_ValidateSeriesOPOR';
                break;
            case 'purchaseInvoice':
                tableName = "OPCH";
                nameSeries = "U_FMB_ValidateSeriesOPCH";
                docSubType = "--";
                docType = "19";
                break;
            case 'GoodsReceipt':
                docType = '20';
                docSubType = '--';
                tableName = 'OPDN';
                nameSeries = 'U_FMB_ValidateSeriesOPDN';
                break;
            case 'SalesHelmets':
                docType = '59';
                docSubType = '--';
                tableName = 'OIGNN';
                nameSeries = 'U_FMB_ValidateSeriesOIGN';
                break;
            case 'transfersRequest':
                docType = "1250000001";
                docSubType = "--";
                tableName = "OWTQ";
                nameSeries = "U_FMB_ValidateSeriesOWTQ";
                break;
            case 'landedCosts':
                docType = "69";
                docSubType = "--";
                tableName = "OIPF";
                nameSeries = "";
                break;
            default:
                docType = '';
                table = '';
                docSubType = '';
                break;
        }
        return { docType, docSubType, nameSeries, tableName }
    };

    selectDocuments = array => {
        this.setState({
            checkboxArray: array
        });
        //console.log(this.state.checkboxArray);
    };

    selectDocumentsToArray = async () => {
        const { newOrderModel, addItem, enableSpinner, view } = this.props;
        const { data } = this.state;
        const { checkboxArray } = this.state;

        let items = [];

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                items.push(data[id]);
            }
        }
        if (newOrderModel.SelectOf !== 'invoice' && view === 'deliveries') {
            newOrderModel.DeliveryAuthorization = 'I'
        }
        let table = this.selectDocType(newOrderModel.SelectOf);

        let arrayDocuments = [];
        for (let i = 0; i < items.length; i++) {
            let info = {
                doc: items[i].DocEntry,
                table: table.tableName,
                docSubType: '--',
            };

            enableSpinner(true);

            let detailsResponse = await apiClient.getDocumentsDetails(info);
            enableSpinner(false);

            arrayDocuments.push(detailsResponse.data);
        }

        addItem(arrayDocuments);

    };

    render() {
        const { newOrderModel, showAlert } = this.props;
        const { data, enable } = this.state;
        //console.log("data Partner", data);

        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="selectOfModal" style={{ zIndex: 91 }}
                role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title "></h4>
                            <button type="button" className="close" onClick={this.closeSelectOf} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ height: 650, maxHeight: 650 }}>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active "
                                            aria-labelledby="nav-home-tab-Contenido">
                                            <table className="table" style={{ marginBottom: 0 }}>
                                                <tbody>
                                                    {enable &&
                                                        <DataTablesCreate data={data} headers={headers} view={"selectOfModal"}
                                                            ref={(ref) => this.dataTable = ref}
                                                            action={this.selectDocuments} search={this.search}
                                                            selectOf={newOrderModel?.SelectOf || ''}
                                                            showAlert={showAlert} />
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={this.closeSelectOf}>Cerrar
                            </button>
                            <button type="button" className="btn botonCorrect"
                                onClick={this.selectDocumentsToArray}>Agregar
                            </button>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        );
    }
}

export default SelectOfModal;